module.exports = __webpack_public_path__ + "img/Ad_Ib_Hrms.dfb94166.png";